import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OffersModalService {
  public openOtherOffersModal$ = new Subject();
}
